export default "__VITE_ASSET__BRftLe2m__"